import { render, staticRenderFns } from "./SwimmingRecord.vue?vue&type=template&id=bb813d9a&scoped=true&"
import script from "./SwimmingRecord.vue?vue&type=script&lang=js&"
export * from "./SwimmingRecord.vue?vue&type=script&lang=js&"
import style0 from "./SwimmingRecord.vue?vue&type=style&index=0&id=bb813d9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb813d9a",
  null
  
)

export default component.exports